import { logger } from '@/lib/logger';

/**
 * Intro-seen flag only — stores `'1'` keyed by assessment response id.
 * Does not store answers, medications, diagnoses, or other PHI.
 * Cleared on assessment completion and on member logout.
 */
const THRIVE_INTRO_STORAGE_PREFIX = 'thrive-check-intro-started:';

export const getThriveIntroStorageKey = (responseIdValue: string) =>
  `${THRIVE_INTRO_STORAGE_PREFIX}${responseIdValue}`;

export const clearThriveIntroStorage = (responseIdValue?: string | null) => {
  if (!responseIdValue) return;
  try {
    sessionStorage.removeItem(getThriveIntroStorageKey(responseIdValue));
  } catch (error) {
    logger.warn('Unable to clear Thrive intro sessionStorage flag', error);
  }
};

export const clearAllThriveIntroStorage = () => {
  try {
    const keysToRemove: string[] = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith(THRIVE_INTRO_STORAGE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    logger.warn('Unable to clear all Thrive intro sessionStorage flags', error);
  }
};
